const firebaseConfig = {
  apiKey: "AIzaSyAjJlk2X_FmF0tmJkZbjBlodM_7MWJeHsM",
  authDomain: "teoraoraraka-asso.firebaseapp.com",
  projectId: "teoraoraraka-asso",
  storageBucket: "teoraoraraka-asso.firebasestorage.app",
  messagingSenderId: "579789586757",
  appId: "1:579789586757:web:8cd8184ea26a1446607e2c"
};

export default firebaseConfig;